<template>
  <div class="settlement-daily-page">
    <div class="nav-header">
      <i class="el-icon-arrow-left" @click="$router.back()"></i>
      <span class="title">结算日报</span>
      <span class="placeholder"></span>
    </div>

    <div class="top-sticky">
      <div class="station-card" @click="showStationPopup = true">
        <span>{{ currentStation }}</span>
        <i class="el-icon-sort rotate-90"></i>
      </div>
    </div>

    <el-dialog title="选择场站" :visible.sync="showStationPopup" width="100%" custom-class="bottom-dialog">
      <div class="station-content">
        <el-input placeholder="输入场站名称" prefix-icon="el-icon-search" v-model="searchKey"></el-input>
        <div class="station-list">
          <div class="station-item" :class="{active: currentStation === '全部场站'}" @click="selectStation('全部场站', null)">
            <span>全部场站</span>
            <i class="el-icon-success" v-if="currentStation === '全部场站'"></i>
          </div>
          <div class="station-item" :class="{active: currentStation === item.plotName}" v-for="item in filteredStationList" :key="item.id" @click="selectStation(item.plotName, item.id)">
            <span>{{ item.plotName }}</span>
            <i class="el-icon-success" v-if="currentStation === item.plotName"></i>
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="chart-card">
      <div class="date-picker" @click="showDatePicker = true">
        {{ currentDate }} <i class="el-icon-caret-bottom"></i>
      </div>
      <div class="chart-main" v-if="dailyData.totalAmount > 0">
        <div class="gauge-container">
          <div id="gaugeChart" style="width: 180px; height: 120px;"></div>
          <div class="gauge-center-text">
            <p class="g-label">结算金额 (元)</p>
            <p class="g-value">{{ formatMoney(dailyData.settleAmount) }}</p>
          </div>
        </div>
        <div class="chart-legend">
          <div class="legend-item">
            <p class="l-label"><span class="dot cyan"></span> 收入总金额 (元)</p>
            <p class="l-value">{{ formatMoney(dailyData.incomeAmount) }}</p>
          </div>
          <div class="legend-item">
            <p class="l-label"><span class="dot gray"></span> 支出总金额 (元)</p>
            <p class="l-value">{{ formatMoney(dailyData.expenseAmount) }}</p>
          </div>
        </div>
      </div>
      <div class="empty-state" v-else>
        <p>暂无数据</p>
      </div>
    </div>

    <div class="detail-card">
      <div class="card-title">支付订单</div>
      <div class="blue-summary-box">
        <p>总订单数 (单)：{{ dailyData.orderCount || 0 }}</p>
        <p>订单总额 (元)：{{ formatMoney(dailyData.orderAmount) }}</p>
        <p>订单电量 (度)：{{ dailyData.powerAmount || 0 }}</p>
      </div>

      <div class="reconcile-list" v-if="dailyData.incomeDetail || dailyData.expenseDetail">
        <div class="item-row main" v-if="dailyData.incomeDetail">
          <span class="label">收入项 (元)</span>
          <span class="value">{{ formatMoney(dailyData.incomeDetail.serviceFee + dailyData.incomeDetail.electricFee) }}</span>
        </div>
        <div class="item-row sub" v-if="dailyData.incomeDetail">
          <span class="label">充电服务费 (元)</span>
          <span class="value">{{ formatMoney(dailyData.incomeDetail.serviceFee) }}</span>
        </div>
        <div class="item-row sub" v-if="dailyData.incomeDetail">
          <span class="label">充电电费 (元)</span>
          <span class="value">{{ formatMoney(dailyData.incomeDetail.electricFee) }}</span>
        </div>

        <div class="divider" v-if="dailyData.incomeDetail && dailyData.expenseDetail"></div>

        <div class="item-row main" v-if="dailyData.expenseDetail">
          <span class="label">支出项 (元)</span>
          <span class="value">{{ formatMoney(dailyData.expenseDetail.techFee + dailyData.expenseDetail.marketingFee) }}</span>
        </div>
        <div class="item-row sub" v-if="dailyData.expenseDetail">
          <span class="label">合同技术服务费 (元)</span>
          <span class="value">{{ formatMoney(dailyData.expenseDetail.techFee) }}</span>
        </div>
        <div class="item-row sub" v-if="dailyData.expenseDetail">
          <span class="label">商家承担营销费用 (元)</span>
          <span class="value">{{ formatMoney(dailyData.expenseDetail.marketingFee) }}</span>
        </div>

        <div class="gray-nested-box" v-if="dailyData.expenseDetail && dailyData.expenseDetail.marketingDetail">
          <div class="item-row">
            <span class="label">营销总费用 (元)</span>
            <span class="value">{{ formatMoney(dailyData.expenseDetail.marketingDetail.totalMarketingFee) }}</span>
          </div>
          <div class="item-row">
            <span class="label">平台营销补贴 (元)</span>
            <span class="value">{{ formatMoney(dailyData.expenseDetail.marketingDetail.platformSubsidy) }}</span>
          </div>
        </div>

        <div class="divider"></div>

        <div class="item-row total-row">
          <span class="label">总结算金额 (元)</span>
          <span class="value">{{ formatMoney(dailyData.settleAmount) }}</span>
        </div>
      </div>
    </div>

    <el-dialog title="选择日期" :visible.sync="showDatePicker" width="90%">
      <el-date-picker
        v-model="selectedDate"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        @change="onDateChange"
      />
      <div slot="footer">
        <el-button @click="showDatePicker = false">取消</el-button>
        <el-button type="primary" @click="confirmDate">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { agentPlotList, getDayProfit, getOrderList } from "@/api/newApi";

export default {
  name: 'SettlementDaily',
  data() {
    return {
      currentStation: '全部场站',
      currentStationId: null,
      currentDate: '请选择日期',
      selectedDate: '',
      showDatePicker: false,
      showStationPopup: false,
      searchKey: '',
      stationList: [],
      dailyData: {
        totalAmount: 0,
        settleAmount: 0,
        incomeAmount: 0,
        expenseAmount: 0,
        orderCount: 0,
        orderAmount: 0,
        powerAmount: 0,
        incomeDetail: null,
        expenseDetail: null
      }
    };
  },
  computed: {
    filteredStationList() {
      if (!this.searchKey) return this.stationList;
      return this.stationList.filter(item =>
        item.plotName && item.plotName.includes(this.searchKey)
      );
    }
  },
  mounted() {
    const today = new Date();
    this.selectedDate = this.formatDate(today);
    this.currentDate = this.formatDateStr(today);
    this.getStationList();
    this.getDailyData();
  },
  updated() {
    this.initGauge();
  },
  methods: {
    initGauge() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('gaugeChart');
        if (!chartDom) return;
        const myChart = echarts.init(chartDom);
        const percent = this.dailyData.incomeAmount > 0
          ? (this.dailyData.settleAmount / this.dailyData.incomeAmount * 100).toFixed(0)
          : 0;
        const option = {
          series: [{
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            radius: '100%',
            center: ['50%', '80%'],
            progress: { show: true, width: 12, itemStyle: { color: '#00BFA5' } },
            axisLine: { lineStyle: { width: 12, color: [[1, '#E6F7F6']] } },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            pointer: { show: false },
            detail: { show: false },
            data: [{ value: percent }]
          }]
        };
        myChart.setOption(option);
      });
    },
    async getStationList() {
      try {
        const res = await agentPlotList({});
        if (res.data && res.data.length > 0) {
          this.stationList = res.data;
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    selectStation(name, id) {
      this.currentStation = name;
      this.currentStationId = id;
      this.showStationPopup = false;
      this.getDailyData();
    },
    async getDailyData() {
      try {
        const params = {
          startTime: this.selectedDate,
          endTime: this.selectedDate,
          plot: this.currentStationId || undefined
        };
        const [profitRes, orderRes] = await Promise.all([
          getDayProfit(params),
          getOrderList({ ...params, pageNo: 1, pageSize: 100, state: '3' })
        ]);

        console.log('日结收益返回:', profitRes);
        console.log('订单列表返回:', orderRes);

        let orderAmount = 0;
        let totalPower = 0;
        let totalServiceFee = 0;
        let totalChargeFee = 0;
        let orderCount = 0;

        if (orderRes.data && orderRes.data.records) {
          orderCount = orderRes.data.records.length;
          orderRes.data.records.forEach(item => {
            orderAmount += parseFloat(item.orderGold || item.price || 0);
            totalPower += parseFloat(item.consumePower || 0);
            totalServiceFee += parseFloat(item.serviceFee || 0);
            totalChargeFee += parseFloat(item.chargeFee || 0);
          });
        }

        const incomeAmount = orderAmount;
        const expenseAmount = totalServiceFee * 0.1;
        const settleAmount = incomeAmount - expenseAmount;

        this.dailyData = {
          totalAmount: incomeAmount,
          settleAmount: settleAmount,
          incomeAmount: incomeAmount,
          expenseAmount: expenseAmount,
          orderCount: orderCount,
          orderAmount: orderAmount,
          powerAmount: totalPower.toFixed(2),
          incomeDetail: {
            serviceFee: totalServiceFee,
            electricFee: totalChargeFee
          },
          expenseDetail: {
            techFee: expenseAmount,
            marketingFee: 0,
            marketingDetail: {
              totalMarketingFee: 0,
              platformSubsidy: 0
            }
          }
        };

      } catch (err) {
        console.log('获取结算日报数据失败', err);
      }
    },
    showHelp() {
      this.$alert('名词解释：...', '名词解释', {
        confirmButtonText: '知道了'
      });
    },
    onDateChange(date) {
      this.selectedDate = date;
    },
    confirmDate() {
      if (this.selectedDate) {
        const date = new Date(this.selectedDate);
        this.currentDate = this.formatDateStr(date);
        this.getDailyData();
      }
      this.showDatePicker = false;
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    formatDateStr(date) {
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${m}月${d}日`;
    },
    formatMoney(val) {
      if (!val && val !== 0) return '0.00';
      return Number(val).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.settlement-daily-page {
  background-color: #F6F8FA;
  min-height: 100vh;
  padding-bottom: 30px;
}

.nav-header {
  background: #FFF;
  padding: 15px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title { font-size: 18px; font-weight: bold; }
  i { font-size: 20px; }
  .help-text { color: #999; font-size: 13px; cursor: pointer; }
}

.top-sticky {
  background: #FFF;
  padding: 10px 16px;
  .station-card {
    background: #F8F9FB;
    padding: 12px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    cursor: pointer;
    .rotate-90 { transform: rotate(90deg); color: #999; }
  }
  .version-tip {
    margin-top: 15px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    .old-version-btn {
      flex-shrink: 0;
      border: 1px solid #DDD;
      padding: 8px 15px;
      border-radius: 4px;
      font-size: 13px;
      cursor: pointer;
    }
    .tip-text {
      font-size: 12px;
      color: #999;
      line-height: 1.5;
      .cyan { color: #00BFA5; }
    }
  }
}

.chart-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 20px 16px;
  .date-picker {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    cursor: pointer;
    i { font-size: 14px; }
  }
  .chart-main {
    display: flex;
    align-items: center;
    .gauge-container {
      position: relative;
      .gauge-center-text {
        position: absolute;
        bottom: 10px;
        left: 0; right: 0;
        text-align: center;
        .g-label { font-size: 11px; color: #999; }
        .g-value { font-size: 18px; font-weight: bold; }
      }
    }
    .chart-legend {
      flex: 1;
      padding-left: 20px;
      .legend-item {
        margin-bottom: 15px;
        &:last-child { margin-bottom: 0; }
        .l-label {
          font-size: 12px; color: #999; margin-bottom: 4px;
          display: flex; align-items: center;
          .dot { width: 6px; height: 6px; border-radius: 50%; margin-right: 6px; }
          .dot.cyan { background: #00BFA5; }
          .dot.gray { background: #E0E0E0; }
        }
        .l-value { font-size: 18px; font-weight: bold; }
      }
    }
  }
  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #999;
  }
}

.detail-card {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 16px;
  .card-title {
    font-size: 17px; font-weight: bold; margin-bottom: 15px;
    padding-bottom: 8px; border-bottom: 3px solid #00BFA5; width: fit-content;
  }
  .blue-summary-box {
    background: #F4F7FA;
    padding: 12px;
    border-radius: 6px;
    font-size: 13px;
    color: #666;
    line-height: 1.8;
  }
  .reconcile-list {
    margin-top: 20px;
    .item-row {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      &.main { font-size: 15px; font-weight: bold; color: #333; }
      &.sub { font-size: 14px; color: #666; padding-left: 5px; }
      &.total-row { border-top: 1px solid #F5F5F5; margin-top: 15px; padding-top: 15px; font-size: 16px; font-weight: bold; }
    }
    .divider { height: 1px; background: #F5F5F5; margin: 10px 0; }
    .gray-nested-box {
      background: #F9F9F9;
      padding: 8px 12px;
      margin: 5px 0 10px;
      .item-row { font-size: 13px; color: #999; padding: 4px 0; }
    }
  }
}
</style>

<style lang="scss">
.station-content {
  .station-list {
    max-height: 400px;
    overflow-y: auto;
    margin-top: 15px;
  }
  .station-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #F0F0F0;
    cursor: pointer;
    &:active { background: #F5F5F5; }
    &.active { color: #00BFA5; }
    i { color: #00BFA5; font-size: 18px; }
  }
}
</style>